const images = {
    logo: require("~/assets/images/logo.jpg"),
    //noImage: require('~/assets/images/no-image.png'),
    heroLight: require("~/assets/images/bg-hero-light.jpg"),
    heroDark: require("~/assets/images/bg-hero-dark.jpg"),
    avatar: require("~/assets/images/avatar.png"),
};

export default images;
